<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit recipe</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="editRecipeState" @submit.prevent="saveNewRecipe" v-if="recipe">
          <v-container fluid grid-list-xl class="pt-0">
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12>
                <validate>
                  <v-text-field
                    v-model="data.recipe.name"
                    required
                    label="Name"
                    name="name"
                    maxlength="40"
                    hide-details
                    counter
                    clearable
                  >
                  </v-text-field>
                  <field-messages
                    name="name"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Name is a required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.recipe.process_id"
                    :items="process"
                    name="process"
                    label="Select process"
                    item-text="name"
                    item-value="id"
                    required
                  />
                  <field-messages
                    name="process"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Process is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.recipe.ingredients"
                    :items="ingredientsLocal"
                    name="ingredients"
                    label="Select ingredients"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                    required
                  />
                  <field-messages
                    name="ingredients"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Ingredients is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
              <v-flex xs12>
                <async-autocomplete
                  v-model="data.recipe.ferments"
                  :items="fermentsLocal"
                  name="ferments"
                  label="Select ferments"
                  item-text="name"
                  item-value="id"
                  return-object
                  multiple
                />
              </v-flex>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.recipe.parameters"
                    :items="parametersLocal"
                    name="parameters"
                    label="Select parameters"
                    item-text="name"
                    item-value="name"
                    return-object
                    multiple
                    required
                  />
                  <field-messages
                    name="parameters"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Parameters is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
            </v-layout>
          </v-container>
        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

export default {
  name: 'editRecipePopup',
  props: {
    dialog: Boolean,
    ingredients: Array,
    ferments: Array,
    parameters: Array,
    process: Array,
    recipe: {
      type: Object,
      default: () => ({
        name: '',
        ingredients: [],
        ferments: [],
        parameters: [],
        process_id: null,
      }),
    },
  },
  data() {
    return {
      data: {
        recipe: JSON.parse(JSON.stringify(this.recipe)),
      },
      editRecipeState: {},
    };
  },
  watch: {
    'recipe': function(nRecipe) {
      this.data.recipe = JSON.parse(JSON.stringify(nRecipe));
    },
    'dialog': function(val) {
      if (val) {
        this.data.recipe = JSON.parse(JSON.stringify(this.recipe));
      }
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    parametersLocal() {
      return this.parameters.map(parameter => ({
        name: parameter.name,
        measure: parameter.measure,
        type: parameter.type,
        target: 0,
        result: 0,
      }));
    },
    ingredientsLocal() {
      return this.ingredients.map(ingredient => ({
        id: ingredient.id,
        name: ingredient.name,
        selectedParameters: ingredient.selectedParameters,
        type: ingredient.type,
        target: 0,
        result: 0,
        isBase: false,
      }));
    },
    fermentsLocal() {
      return this.ferments.map(ferment => ({
        id: ferment.id,
        name: ferment.name,
        selectedParameters: ferment.selectedParameters,
        type: ferment.type,
        target: 0,
        result: 0,
        isBase: false,
      }));
    },
  },
  methods: {
    close() {
      this.editRecipeState._reset();
      this.dialogLocal = false;
    },
    saveNewRecipe() {
      if (!this.editRecipeState.$valid) {
        return;
      }
      this.$emit('updateRecipe', this.data);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
